<div class="education-editor">
  <div class="control-custom">
    <div>{{ 'label.EducationLevel' | translate }}</div>
    <div>
      <select
        name="educationLevel"
        [ngModel]="
          education &&
          education.educationLevel &&
          education.educationLevel.educationLevelId
        "
        (ngModelChange)="
          education &&
            education.educationLevel &&
            (education.educationLevel.educationLevelId = $event)
        "
        (change)="onLevelChange($event)"
        convert-to-number
      >
        <option
          *ngFor="let item of educationLevelList"
          [value]="item.value"
          [selected]="item.value == education?.educationLevel?.educationLevelId"
        >
          {{ item.text }}
        </option>
      </select>
    </div>
  </div>
  <div class="control-custom">
    <div>{{ 'label.From' | translate }}</div>
    <div class="container" style="padding-left: 0px">
      <div class="col-md-1" style="padding-left: 0px">
        <select
          name="fromMonth"
          [ngModel]="education && education.dateFromMonth"
          (ngModelChange)="education && (education.dateFromMonth = $event)"
          convert-to-number
        >
          <option
            *ngFor="let item of monthList"
            [value]="item.value"
            [selected]="item.value == education?.dateFromMonth"
          >
            {{ item.text }}
          </option>
        </select>
      </div>
      <div class="col-md-11" style="padding-left: 2px">
        <input
          type="text"
          placeholder="{{ 'label.Year' | translate }}"
          size="5"
          [ngModel]="education && education.dateFromYear"
          (ngModelChange)="education && (education.dateFromYear = $event)"
          maxlength="4"
          required
        />
      </div>
      <div class="col-md-1" style="padding-left: 0px">
        <hr-field-state-marker
          [field]="field?.dateFromMonth"
        ></hr-field-state-marker>
      </div>
      <div class="col-md-1" style="padding-left: 0px">
        <hr-field-state-marker
          [field]="field?.dateFromYear"
        ></hr-field-state-marker>
      </div>
    </div>
  </div>
  <div class="control-custom">
    <div>{{ 'label.To' | translate }}</div>
    <div class="container" style="padding-left: 0px">
      <div class="col-md-1" style="padding-left: 0px">
        <select
          name="toMonth"
          [ngModel]="education && education.dateToMonth"
          (ngModelChange)="education && (education.dateToMonth = $event)"
          convert-to-number
        >
          <option
            *ngFor="let item of monthList"
            [value]="item.value"
            [selected]="item.value == education?.dateToMonth"
          >
            {{ item.text }}
          </option>
        </select>
      </div>
      <div class="col-md-11" style="padding-left: 2px">
        <input
          type="text"
          placeholder="{{ 'label.Year' | translate }}"
          size="5"
          [ngModel]="education && education.dateToYear"
          (ngModelChange)="education && (education.dateToYear = $event)"
          maxlength="4"
          required
        />
        <span style="color: gray">{{
          'label.OrExpectedGraduationYear' | translate
        }}</span>
      </div>
      <div class="col-md-1" style="padding-left: 0px">
        <hr-field-state-marker
          [field]="field?.dateToMonth"
        ></hr-field-state-marker>
      </div>
      <div class="col-md-1" style="padding-left: 0px">
        <hr-field-state-marker
          [field]="field?.dateToYear"
        ></hr-field-state-marker>
      </div>
    </div>
  </div>
  <div
    *ngIf="
      education?.educationLevel?.educationLevelId ==
        EducationLevelEnum.Bachelor ||
      education?.educationLevel?.educationLevelId ==
        EducationLevelEnum.Master ||
      education?.educationLevel?.educationLevelId ==
        EducationLevelEnum.Doctorate
    "
  >
    <div class="control-custom">
      <div>
        {{
          'label.' +
            educationLabelList[education?.educationLevel?.educationLevelId]
            | translate
        }}
      </div>
      <div>
        <p-autoComplete
          [ngModel]="education && education.educationalInstitution"
          (ngModelChange)="
            education && (education.educationalInstitution = $event)
          "
          [suggestions]="educationalInstitutions"
          (completeMethod)="searchInstitute($event)"
          (onSelect)="onInstituteSelect($event)"
          [minLength]="1"
          field="name"
          [dropdown]="true"
          [size]="50"
        >
          <ng-template let-edu pTemplate="item">
            <span>{{ edu.name }}</span>
          </ng-template>
        </p-autoComplete>
      </div>
    </div>
    <div class="control-custom">
      <div>{{ 'EducationalProgram' | translate }}</div>
      <div>
        <p-autoComplete
          [ngModel]="education && education.educationalProgram"
          (ngModelChange)="education && (education.educationalProgram = $event)"
          [suggestions]="educationalPrograms"
          (completeMethod)="searchProgram($event)"
          [minLength]="1"
          field="name"
          [dropdown]="true"
          [size]="50"
        >
          <ng-template let-program pTemplate="item">
            <span>{{ program.name }}</span>
          </ng-template>
        </p-autoComplete>
      </div>
    </div>
  </div>
  <div
    class="control-custom"
    *ngIf="
      education?.educationLevel?.educationLevelId &&
      education?.educationLevel?.educationLevelId !=
        EducationLevelEnum.Bachelor &&
      education?.educationLevel?.educationLevelId !=
        EducationLevelEnum.Master &&
      education?.educationLevel?.educationLevelId !=
        EducationLevelEnum.Doctorate
    "
  >
    <div>
      {{
        'label.' +
          educationLabelList[education?.educationLevel?.educationLevelId]
          | translate
      }}
    </div>
    <div>
      <input
        type="text"
        name="institution"
        style="width: 300px"
        maxlength="200"
        [ngModel]="education && education.institution"
        (ngModelChange)="education && (education.institution = $event)"
      />
    </div>
    <div style="padding-left: 0px">
      <hr-field-state-marker [field]="field?.institute"></hr-field-state-marker>
    </div>
  </div>
  <div
    class="control-custom"
    *ngIf="
      education?.educationLevel?.educationLevelId !=
        EducationLevelEnum.IncompleteHighSchool &&
      education?.educationLevel?.educationLevelId !=
        EducationLevelEnum.HighSchool
    "
  >
    <div>{{ 'label.Specialization' | translate }}</div>
    <div>
      <input
        type="text"
        name="specialization"
        style="width: 300px"
        maxlength="200"
        [ngModel]="education && education.specialization"
        (ngModelChange)="education && (education.specialization = $event)"
      />
    </div>
    <div style="padding-left: 0px">
      <hr-field-state-marker [field]="field?.program"></hr-field-state-marker>
    </div>
  </div>
  <div class="control-custom">
    <div>{{ 'label.AdditionalInformation' | translate }}</div>
    <div style="max-width: 500px" class="form-group">
      <textarea
        class="form-control"
        [ngModel]="education && education.description"
        (ngModelChange)="education && (education.description = $event)"
        rows="3"
      ></textarea>
    </div>
  </div>
  <div class="control-custom">
    <div>{{ 'label.AttachmentEgDiploma' | translate }}</div>
    <div *ngIf="education?.attachment != null">
      <span>{{ education.attachment.fileName }} &nbsp; &nbsp;</span>
      <button (click)="onDeleteEducationAttachmentClick(education)">
        {{ 'label.Delete' | translate }}
      </button>
    </div>
    <div>
      <label class="upload-button">
        <input
          type="file"
          ngFileSelect
          [options]="uploadOptions"
          [uploadInput]="uploadInput"
          (uploadOutput)="onUploadOutput($event)"
        />
      </label>
    </div>
  </div>
  <div class="control-custom" style="margin-top: 15px">
    <button class="btn btn-default" (click)="onSaveEducationClick()">
      {{ 'label.Save' | translate }}
    </button>
    <button class="btn btn-default" (click)="onCancelEducationClick()">
      {{ 'label.Cancel' | translate }}
    </button>
  </div>
</div>
